"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _Spacer = require("../Spacer");

var _Text = require("../Text");

var _v = require("./tokens/v2");

var _v2 = require("./tokens/v3");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Input component */
var Input = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      disabled = _ref.disabled,
      error = _ref.error,
      required = _ref.required,
      focus = _ref.focus,
      hover = _ref.hover,
      title = _ref.title,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["children", "className", "description", "disabled", "error", "required", "focus", "hover", "title", "height"]);

  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
      _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
      boxProps = _splitBoxProps2[0],
      inputProps = _splitBoxProps2[1];

  var tokens = (0, _Theme.useThemeConfig)({
    v2: {
      height: height !== null && height !== void 0 ? height : 40,
      titleVariant: "text",
      titleTextTransform: null,
      secondaryTextVariant: "small"
    },
    v3: {
      height: height !== null && height !== void 0 ? height : 50,
      titleVariant: "xs",
      titleTextTransform: "uppercase",
      secondaryTextVariant: "xs"
    }
  });
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    width: "100%",
    className: className
  }, boxProps), (title || description) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.titleVariant,
    textTransform: tokens.titleTextTransform
  }, title, required && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    as: "span",
    color: "brand"
  }, "*")), description && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.secondaryTextVariant,
    color: "black60"
  }, description)), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    m: 0.5
  })), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    ref: ref,
    disabled: disabled,
    focus: focus,
    hover: hover,
    error: !!error,
    required: required,
    height: tokens.height
  }, inputProps)), children), error && typeof error === "string" && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: tokens.secondaryTextVariant,
    mt: 0.5,
    color: "red100"
  }, error));
});

exports.Input = Input;

var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "bysdh7-0"
})(["width:100%;padding:0 ", ";appearance:none;line-height:1;border:1px solid;border-radius:0;transition:border-color 0.25s;font-family:", ";", ";", ";"], (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("fonts.sans"), _styledSystem.height, function (props) {
  var states = (0, _Theme.getThemeConfig)(props, {
    v2: _v.INPUT_STATES,
    v3: _v2.INPUT_STATES
  });
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " &:hover{", "}&:focus{outline:none;", "}&:disabled{cursor:default;", "}"], states.default, props.hover && states.hover, props.focus && states.focus, props.disabled && states.disabled, props.error && states.error, states.hover, states.focus, states.disabled);
});
//# sourceMappingURL=Input.js.map